import { observer } from "mobx-react-lite";
import React, { useContext, useEffect, useState } from "react";
import classes from "./PartnersSection.module.scss";
import cs from "classnames";
import { StoreContext } from "../../../contexts";
import {
  APPLICATION_ROUTES,
  PARTNERSHIP_STATUS,
  PROJECTS,
} from "../../../constants";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import Icon from "../../atoms/Icon";
import { NAMES, SIZES } from "../../atoms/Icon/utilities";
import balloon from "../../../assets/images/balloon.png";
import hand from "../../../assets/images/Hand.png";
import verticalShadow from "../../../assets/images/verticle-shadow.png";
import horizontalShadow from "../../../assets/images/horizontal-shadow.png";
import { ACTIONS } from "../../../store";
import Logotype, { TYPES as LOGOTYPE_TYPES } from "../../atoms/Logotype";
import partnersCard from "../../../assets/images/partners-card.png";

const PartnersSection = observer(({ discount = false }) => {
  const { partnership, authorization } = useContext(StoreContext);
  const history = useHistory();

  const [monthlyPlan, setMonthlyPlan] = useState(false);
  const [currentPlan, setCurrentPlan] = useState("");
  const [currentPlanBillingInterval, setCurrentPlanBillingInterval] =
    useState("");

  console.log(monthlyPlan);

  useEffect(() => {
    partnership[`${ACTIONS.PARTNERSHIP.GET_PARTNERSHIP}`]();
  }, []);

  useEffect(() => {
    if (
      partnership.hasDetails &&
      (partnership.details["status"] == PARTNERSHIP_STATUS.ACTIVE ||
        partnership.details["status"] == PARTNERSHIP_STATUS.PENDING ||
        Date.now() < new Date(partnership.details["expiration_date"]))
    ) {
      setCurrentPlan(
        partnership.details["plan"].toLowerCase().replace("-", "_")
      );
      setCurrentPlanBillingInterval(partnership.details["interval"]);
      if (partnership.details["interval"] == 1) {
        setMonthlyPlan(true);
      }
    }
  }, [partnership.details]);

  const onSubmitAndNavigateToPayment = ({ projectType, billingCycle }) => {
    const pageParam = discount && projectType === PROJECTS.PARTNERS.PACKAGES.BASIC_TIER.ID && billingCycle === 12
      ? ''
      : '';

    if (authorization.user === null) {
      // history.push(
      //   `${APPLICATION_ROUTES.SIGN_IN}?redirect=${APPLICATION_ROUTES.PARTNERS_ORDER}/${projectType}/${billingCycle}`
      // );

      if(location.href.includes(APPLICATION_ROUTES.NINETEEN_KISLEV)) {
        history.push(
          `${APPLICATION_ROUTES.SIGN_IN}?redirect=${APPLICATION_ROUTES.NINETEEN_KISLEV}`
        );
      } else {
        history.push(
          `${APPLICATION_ROUTES.SIGN_IN}?redirect=${APPLICATION_ROUTES.PARTNERS_PACKAGES}`
        );
      }
    } else {
      if (
        (currentPlan == PROJECTS.PARTNERS.PACKAGES.PARTNER_TIER.ID ||
          currentPlan == PROJECTS.PARTNERS.PACKAGES.SILVER_CARD_TIER.ID) &&
        (projectType == PROJECTS.PARTNERS.PACKAGES.SILVER_CARD_TIER.ID ||
          projectType == PROJECTS.PARTNERS.PACKAGES.GOLD_TIER.ID)
      ) {
        history.push(
          `${APPLICATION_ROUTES.CHECKOUT}/${projectType}/${billingCycle}/partnership?delivery=false${pageParam}`
        );
      } else {
        if (
          projectType == PROJECTS.PARTNERS.PACKAGES.BASIC_TIER.ID ||
          projectType == PROJECTS.PARTNERS.PACKAGES.SILVER_TIER.ID
        ) {
          history.push(
            `${APPLICATION_ROUTES.CHECKOUT}/${projectType}/${billingCycle}/partnership?${pageParam.replace('&', '')}`
          );
        } else {
          history.push(
            `${APPLICATION_ROUTES.PARTNERS_ORDER}/${projectType}/${billingCycle}`
          );
        }
      }
    }
  };

  return (
    <>
      {location.href.includes(APPLICATION_ROUTES.PARTNERS_PACKAGES) || location.href.includes(APPLICATION_ROUTES.NINETEEN_KISLEV) ? (
        <div className={cs("")}>
          <div className="wrapper-xl d-flex jc-center">
            <Logotype type={LOGOTYPE_TYPES.PARTNERS} />
          </div>
        </div>
      ) : null}

      <div
        className={cs(
          classes.partnersFooter,
          location.href.includes(APPLICATION_ROUTES.PARTNERS_PACKAGES) &&
          classes.packagePagePadding,
          location.href.includes(APPLICATION_ROUTES.NINETEEN_KISLEV) &&
          classes.packagePagePadding,
          "wrapper-m"
        )}
      >

        {
          discount &&
          <h2 className={cs(classes.discountApplied)}>
            Yud Tes Kislev <br className={cs(classes.discountAppliedBreak)} /> discount applied!
          </h2>
        }
        {/* Basic Package - Desktop */}
        <div className={cs(classes.limitedOfferContainer, classes.bronzeOffer, classes.basicPlanDesktop)}>
          {!partnership?.details?.free_trial_used && (
            <div className={cs(classes.freeTrailContainer)}>
              <p>14-Day Free Trial</p>
              <p className={cs(classes.freeTrailText)}>on the yearly plan</p>
            </div>
          )}
          <div className={cs(classes.limitedOfferRight, classes.basicPlanRightContainer)}>
            <div className={cs(classes.basicPlanRightContent)}>

              <h1 className={cs(classes.discountedPrice)}>
                <div>
                  <strong>Basic Yearly Package</strong>  <br />
                  <span className={cs(discount && classes.crossedOutPrice)}>
                    <strong>${PROJECTS.PARTNERS.PACKAGES.BASIC_TIER.COST_YEAR}</strong>/Year
                  </span>
                </div>
                {discount && (
                  <div className={cs(classes.discountedPriceText)}>
                    <strong>${PROJECTS.PARTNERS.PACKAGES.BASIC_TIER.COST_YEAR - PROJECTS.PARTNERS.PACKAGES.BASIC_TIER.DISCOUNT_YEAR}</strong>/Year
                    {" "}
                    <span className={cs(classes.silverPercentage)}>
                      (10% OFF)
                    </span>
                  </div>
                )}
              </h1>

              {(currentPlan == PROJECTS.PARTNERS.PACKAGES.BASIC_TIER.ID &&
                currentPlanBillingInterval == 12) || !currentPlan ? (
                <div className={cs(classes.limitedOfferLeft, classes.basicPlanRightButton)}>
                  <div
                    onClick={() =>
                      onSubmitAndNavigateToPayment({
                        projectType: PROJECTS.PARTNERS.PACKAGES.BASIC_TIER.ID,
                        billingCycle: 12,
                      })
                    }
                    className={cs(
                      classes.birthdayDiscountButtonBasic,
                      currentPlan == PROJECTS.PARTNERS.PACKAGES.BASIC_TIER.ID &&
                      currentPlanBillingInterval == 12 &&
                      classes.disableButton
                    )}
                  >
                    {currentPlan == PROJECTS.PARTNERS.PACKAGES.BASIC_TIER.ID &&
                      currentPlanBillingInterval == 12 ? (
                      "CURRENT PLAN"
                    ) : (
                      <>
                        JOIN NOW
                      </>
                    )}
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>

            <img
              className={cs(
                classes.verticalShadow,
                classes.basicVerticalShadow,
                classes.basicPlanLeftLine
              )}
              src={verticalShadow}
              alt="verticalShadow"
            />
            <div className={cs(classes.limitedOfferInfo)}>
              <div className={cs(classes.limitedOfferInfoText)}>
                <Icon size={SIZES.XS} name={NAMES.BrownTick} />
                <p>Full Library Access</p>
              </div>
              <div
                className={cs(classes.limitedOfferInfoText, classes.disabled)}
              >
                <Icon size={SIZES.XS} name={NAMES.MinusIcon} />
                <p>No Maor Partner Card</p>
              </div>
            </div>

            <img
              className={cs(
                classes.verticalShadow,
                classes.basicVerticalShadow,
                classes.basicPlanRightLine
              )}
              src={verticalShadow}
              alt="verticalShadow"
            />
            <div className={cs(classes.basicPlanLeftContent)}>
              <h1>
                <strong>Basic Monthly Package</strong> <br />{" "}
                <span>
                  <strong>${PROJECTS.PARTNERS.PACKAGES.BASIC_TIER.COST_MONTH}</strong>/Month
                </span>
              </h1>

              {(currentPlan == PROJECTS.PARTNERS.PACKAGES.BASIC_TIER.ID &&
                currentPlanBillingInterval == 1) || !currentPlan ? (
                <div className={cs(classes.limitedOfferLeft, classes.basicPlanLeftButton)}>
                  <div
                    onClick={() =>
                      onSubmitAndNavigateToPayment({
                        projectType: PROJECTS.PARTNERS.PACKAGES.BASIC_TIER.ID,
                        billingCycle: 1,
                      })
                    }
                    className={cs(
                      classes.birthdayDiscountButtonBasic,
                      currentPlan == PROJECTS.PARTNERS.PACKAGES.BASIC_TIER.ID &&
                      currentPlanBillingInterval == 1 &&
                      classes.disableButton
                    )}
                  >
                    {currentPlan == PROJECTS.PARTNERS.PACKAGES.BASIC_TIER.ID &&
                      currentPlanBillingInterval == 1 ? (
                      "CURRENT PLAN"
                    ) : (
                      <>
                        JOIN NOW
                      </>
                    )}
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
          <img
            className={cs(classes.horizontalShadow)}
            src={horizontalShadow}
            alt="verticalShadow"
          />

        </div>

        {/* Basic Package - Mobile */}
        <div className={cs(classes.limitedOfferContainer, classes.bronzeOffer, classes.basicPlanMobile)}>
          {!partnership?.details?.free_trial_used && (
            <div className={cs(classes.freeTrailContainer)}>
              <p>14-Day Free Trial</p>
              <p className={cs(classes.freeTrailText)}>on the yearly plan</p>
            </div>
          )}

          <h1 className={cs(classes.basicPlanMobileTitle)}>
            <strong>Basic Package</strong>
          </h1>

          <div className={cs(classes.basicPlanMobileFeatures)}>
            <div className={cs(classes.limitedOfferInfoText)}>
              <Icon size={SIZES.XS} name={NAMES.BrownTick} />
              <p>Full Library Access</p>
            </div>
            <div className={cs(classes.limitedOfferInfoText, classes.disabled)}>
              <Icon size={SIZES.XS} name={NAMES.MinusIcon} />
              <p>Maor Partner Card</p>
            </div>
          </div>

          <img
            src={horizontalShadow}
            alt="horizontalShadow"
            className={cs(classes.horizontalShadow)}
          />

          <div className={cs(classes.basicPlanMobilePricing)}>
            <div className={cs(classes.basicPlanMobilePriceBox)}>
              <p className={cs(classes.basicPlanMobileLabel)}>Yearly subscription</p>
              <h2>
                <strong className={cs(discount && classes.crossedOutPrice)}>${PROJECTS.PARTNERS.PACKAGES.BASIC_TIER.COST_YEAR}/Year</strong>
                {discount && (
                  <div>
                    <strong>${PROJECTS.PARTNERS.PACKAGES.BASIC_TIER.COST_YEAR - PROJECTS.PARTNERS.PACKAGES.BASIC_TIER.DISCOUNT_YEAR}</strong>/Year
                    {" "}
                    <br />
                    <span className={cs(classes.silverPercentage)}>
                      (10% OFF)
                    </span>
                  </div>
                )}
              </h2>
              {((currentPlan == PROJECTS.PARTNERS.PACKAGES.BASIC_TIER.ID &&
                currentPlanBillingInterval == 12) || !currentPlan) && (
                  <div
                    onClick={() =>
                      onSubmitAndNavigateToPayment({
                        projectType: PROJECTS.PARTNERS.PACKAGES.BASIC_TIER.ID,
                        billingCycle: 12,
                      })
                    }
                    className={cs(
                      classes.basicPlanMobileButton,
                      classes.basicPlanMobileButtonAlt,
                      currentPlan == PROJECTS.PARTNERS.PACKAGES.BASIC_TIER.ID &&
                      currentPlanBillingInterval == 12 && classes.disableButton
                    )}
                  >
                    {currentPlan == PROJECTS.PARTNERS.PACKAGES.BASIC_TIER.ID &&
                      currentPlanBillingInterval == 12 ? "CURRENT PLAN" : "JOIN NOW"}
                  </div>
                )}
            </div>

            <div className={cs(classes.basicPlanMobilePriceBox)}>
              <p className={cs(classes.basicPlanMobileLabel)}>Monthly subscription</p>
              <h2>
                <strong>${PROJECTS.PARTNERS.PACKAGES.BASIC_TIER.COST_MONTH}</strong>/Month
              </h2>
              {((currentPlan == PROJECTS.PARTNERS.PACKAGES.BASIC_TIER.ID &&
                currentPlanBillingInterval == 1) || !currentPlan) && (
                  <div
                    onClick={() =>
                      onSubmitAndNavigateToPayment({
                        projectType: PROJECTS.PARTNERS.PACKAGES.BASIC_TIER.ID,
                        billingCycle: 1,
                      })
                    }
                    className={cs(
                      classes.basicPlanMobileButton,
                      // classes.basicPlanMobileButtonAlt,
                      currentPlan == PROJECTS.PARTNERS.PACKAGES.BASIC_TIER.ID &&
                      currentPlanBillingInterval == 1 && classes.disableButton
                    )}
                  >
                    {currentPlan == PROJECTS.PARTNERS.PACKAGES.BASIC_TIER.ID &&
                      currentPlanBillingInterval == 1 ? "CURRENT PLAN" : "JOIN NOW"}
                  </div>
                )}
            </div>
          </div>
        </div>

        {/* Partner Package */}
        <div className={cs(classes.limitedOfferContainer, classes.widerBox)}>
          <div className={cs(classes.limitedOfferRight)}>
            <img
              className={cs(classes.limitedOfferImage)}
              src={partnersCard}
              alt="partnersCard"
            />

            <h1
              className={cs(
                classes.tempMarginClass,
                classes.maorPartneCardText,
              )}
            >
              <strong>
                Maor Partner Card{" "}
                <br className={cs(classes.maorPartnerHeadingBreak)} /> Package
              </strong>{" "}
              <br />{" "}
              <span className={cs(classes.partnerCardPriceDesktop)}>
                {" "}
                <b>${PROJECTS.PARTNERS.PACKAGES.PARTNER_TIER.COST_YEAR}</b>/Year
              </span>
            </h1>

            <img
              className={cs(classes.verticalShadow)}
              src={verticalShadow}
              alt="verticalShadow"
            />
            <div className={cs(classes.limitedOfferInfo)}>
              <div className={cs(classes.limitedOfferInfoText)}>
                <Icon size={SIZES.XS} name={NAMES.OrangeTick} />
                <p>Full Library Access</p>
              </div>
              <div className={cs(classes.limitedOfferInfoText)}>
                <Icon size={SIZES.XS} name={NAMES.OrangeTick} />
                <p>Maor Partner Card</p>
              </div>
            </div>

          </div>
          <img
            className={cs(classes.horizontalShadow)}
            src={horizontalShadow}
            alt="verticalShadow"
          />

          <div className={cs(classes.partnerCardPriceContainer)}>
            <h1
              className={cs(
                classes.tempMarginClass,
                classes.maorPartneCardText,
                classes.partnerCardPriceMobile
              )}
            >
              <b>${PROJECTS.PARTNERS.PACKAGES.PARTNER_TIER.COST_YEAR}</b>/Year
            </h1>
            {currentPlan == PROJECTS.PARTNERS.PACKAGES.PARTNER_TIER.ID || !currentPlan ? (
              <div className={cs(classes.limitedOfferLeft)}>
                <div
                  onClick={() =>
                    onSubmitAndNavigateToPayment({
                      projectType: PROJECTS.PARTNERS.PACKAGES.PARTNER_TIER.ID,
                      billingCycle: 12,
                    })
                  }
                  className={cs(
                    classes.limitedOfferButton,
                    currentPlan == PROJECTS.PARTNERS.PACKAGES.PARTNER_TIER.ID &&
                    classes.disableButton
                  )}
                >
                  {currentPlan == PROJECTS.PARTNERS.PACKAGES.PARTNER_TIER.ID ? (
                    "CURRENT PLAN"
                  ) : (
                    <>
                      JOIN NOW
                    </>
                  )}
                </div>
              </div>
            ) : (
              ""
            )}
          </div>

        </div>

        <div className={cs(classes.partnersFooterBottom)}>
          <div className={cs(classes.birthdayDiscount)}>
            <img src={balloon} alt="balloon" className={cs(classes.balloon)} />
            <div className={cs(classes.birthdayDiscountTop)}>
              <h4>Birthday Discount Package</h4>
              <div className={cs(classes.birthdayDiscountInfoContainer)}>
                <div className={cs(classes.birthdayDiscountInfo)}>
                  <Icon size={SIZES.XS} name={NAMES.BrownTick} />
                  <p>Up to 4 Birthday Celebrations</p>
                </div>
                <div className={cs(classes.birthdayDiscountInfo)}>
                  <Icon size={SIZES.XS} name={NAMES.BrownTick} />
                  <p>Full Library Access </p>
                </div>
                <div className={cs(classes.birthdayDiscountInfo)}>
                  <Icon size={SIZES.XS} name={NAMES.BrownTick} />
                  <p>Optional: Maor Partner Card</p>
                </div>
              </div>
            </div>

            <div className={cs(classes.birthdayDiscountBottom)}>
              <img
                src={horizontalShadow}
                alt="horizontalShadow"
                className={cs(classes.horizontalShadow)}
              />

              <div
                className={cs(
                  classes.maorSupporterBottomConatiner,
                  classes.silverBottomContainer
                )}
              >
                <div className={cs(classes.priceBox)}>
                  <div
                    className={cs(
                      classes.maorSupporterBottom,
                      classes.silverBottom
                    )}
                  >
                    <p className={cs(classes.withoutCardText)}>Without Card</p>
                    <p
                      className={cs(
                        classes.birthdayDiscountPrice,
                        classes.silverDiscountPrice
                      )}
                    >

                      <>
                        ${PROJECTS.PARTNERS.PACKAGES.SILVER_TIER.COST_YEAR}/Year
                        <span className={cs(classes.silverPercentage)}>
                          {" "}
                          (17% OFF)
                        </span>
                      </>

                    </p>
                    {(currentPlan == PROJECTS.PARTNERS.PACKAGES.SILVER_TIER.ID &&
                      currentPlanBillingInterval == 12) || !currentPlan ? (
                      <div
                        onClick={() =>
                          onSubmitAndNavigateToPayment({
                            projectType:
                              PROJECTS.PARTNERS.PACKAGES.SILVER_TIER.ID,
                            billingCycle: 12,
                          })
                        }
                        className={cs(
                          classes.birthdayDiscountButton,
                          currentPlan ==
                          PROJECTS.PARTNERS.PACKAGES.SILVER_TIER.ID &&
                          currentPlanBillingInterval == 12 &&
                          classes.disableButton
                        )}
                      >
                        {currentPlan ==
                          PROJECTS.PARTNERS.PACKAGES.SILVER_TIER.ID &&
                          currentPlanBillingInterval == 12 ? (
                          "CURRENT PLAN"
                        ) : (
                          <>
                            JOIN NOW
                          </>
                        )}
                      </div>
                    ) : ""}
                  </div>
                  <p className={cs(classes.orText)}> or</p>
                  <div
                    className={cs(
                      classes.maorSupporterBottom,
                      classes.silverBottom
                    )}
                  >
                    <p className={cs(classes.withCardText)}>With Card</p>
                    <p
                      className={cs(
                        classes.birthdayDiscountPrice,
                        classes.silverDiscountPrice
                      )}
                    >
                      <>
                        ${PROJECTS.PARTNERS.PACKAGES.SILVER_CARD_TIER.COST_YEAR}/Year
                        <span className={cs(classes.silverPercentage)}>
                          {" "}
                          (28% OFF)
                        </span>
                      </>
                    </p>
                    {
                      (currentPlan ==
                        PROJECTS.PARTNERS.PACKAGES.SILVER_CARD_TIER.ID &&
                        currentPlanBillingInterval == 12) || !currentPlan ?
                        (
                          <div
                            onClick={() =>
                              onSubmitAndNavigateToPayment({
                                projectType:
                                  PROJECTS.PARTNERS.PACKAGES.SILVER_CARD_TIER.ID,
                                billingCycle: 12,
                              })
                            }
                            className={cs(
                              classes.birthdayDiscountButton,
                              currentPlan ==
                              PROJECTS.PARTNERS.PACKAGES.SILVER_CARD_TIER.ID &&
                              currentPlanBillingInterval == 12 &&
                              classes.disableButton
                            )}
                          >
                            {currentPlan ==
                              PROJECTS.PARTNERS.PACKAGES.SILVER_CARD_TIER.ID &&
                              currentPlanBillingInterval == 12 ? (
                              "CURRENT PLAN"
                            ) : (
                              <>
                                JOIN NOW
                              </>
                            )}
                          </div>
                        ) : ""}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={cs(classes.maorSupporter)}>
            <img src={hand} alt="hand" className={cs(classes.handShake)} />
            <div className={cs(classes.maorSupporterTop)}>
              <h4>Become a Maor Supporter!</h4>
              <div className={cs(classes.maorSupporterInfoContainer)}>
                <div className={cs(classes.maorSupporterInfo)}>
                  <Icon size={SIZES.XS} name={NAMES.BrownTick} />
                  <p>Full Birthday Celebration for the Entire Family</p>
                </div>
                <div className={cs(classes.maorSupporterInfo)}>
                  <Icon size={SIZES.XS} name={NAMES.BrownTick} />
                  <p>Full Library Access</p>
                </div>
                <div className={cs(classes.maorSupporterInfo)}>
                  <Icon size={SIZES.XS} name={NAMES.BrownTick} />
                  <p>Maor Partner Card + Gift a 2nd card to a friend</p>
                </div>
              </div>
            </div>
            <div className={cs(classes.maorSupporterBottomInfo)}>
              <img
                src={horizontalShadow}
                alt="horizontalShadow"
                className={cs(classes.horizontalShadow)}
              />
              <div
                className={cs(
                  classes.maorSupporterBottomConatiner,
                  classes.goldContainer
                )}
              >
                <div
                  className={cs(
                    classes.withWithoutCardBox,
                    classes.withCardText
                  )}
                >
                  With Card
                </div>
                <div className={cs(classes.priceBox)}>
                  <div className={cs(classes.maorSupporterBottom)}>
                    <p className={cs(classes.maorSupporterPrice)}>${PROJECTS.PARTNERS.PACKAGES.GOLD_TIER.COST_MONTH}/Month</p>
                    {
                      (currentPlan ==
                        PROJECTS.PARTNERS.PACKAGES.GOLD_TIER.ID &&
                        currentPlanBillingInterval == 1) || !currentPlan ?
                        <div
                          className={cs(
                            classes.maorSupporterButton,
                            currentPlan ==
                            PROJECTS.PARTNERS.PACKAGES.GOLD_TIER.ID &&
                            currentPlanBillingInterval == 1 &&
                            classes.disableButton
                          )}
                          onClick={() =>
                            onSubmitAndNavigateToPayment({
                              projectType: PROJECTS.PARTNERS.PACKAGES.GOLD_TIER.ID,
                              billingCycle: 1,
                            })
                          }
                        >
                          {currentPlan == PROJECTS.PARTNERS.PACKAGES.GOLD_TIER.ID &&
                            currentPlanBillingInterval == 1 ? (
                            "CURRENT PLAN"
                          ) : (
                            <>
                              JOIN NOW
                            </>
                          )}
                        </div> : " "}
                  </div>
                  <p className={cs(classes.orText)}> or</p>
                  <div className={cs(classes.maorSupporterBottom)}>
                    <p className={cs(classes.maorSupporterPrice)}>${PROJECTS.PARTNERS.PACKAGES.GOLD_TIER.COST_YEAR}/Year</p>
                    {
                      (currentPlan ==
                        PROJECTS.PARTNERS.PACKAGES.GOLD_TIER.ID &&
                        currentPlanBillingInterval == 12) || !currentPlan ?
                        <div
                          className={cs(
                            classes.maorSupporterButton,
                            currentPlan ==
                            PROJECTS.PARTNERS.PACKAGES.GOLD_TIER.ID &&
                            currentPlanBillingInterval == 12 &&
                            classes.disableButton
                          )}
                          onClick={() =>
                            onSubmitAndNavigateToPayment({
                              projectType: PROJECTS.PARTNERS.PACKAGES.GOLD_TIER.ID,
                              billingCycle: 12,
                            })
                          }
                        >
                          {currentPlan == PROJECTS.PARTNERS.PACKAGES.GOLD_TIER.ID &&
                            currentPlanBillingInterval == 12 ? (
                            "CURRENT PLAN"
                          ) : (
                            <>
                              JOIN NOW
                            </>
                          )}
                        </div>
                        : ""
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
});

export default PartnersSection;
